import { AutocompleteResult, SearchAutocompleteSection } from "../types";

import clsx from "clsx";
import { WorkspaceBadge } from "./WorkspaceBadge";

export interface ListItem {
  result: AutocompleteResult;
  section: SearchAutocompleteSection;
}

interface ListSectionProps {
  item: ListItem;
  totalIndex: number;
  highlightedIndex: number;
  isMouseActive: boolean;
  onSelect: (item: ListItem) => void;
  highlightedRef: React.RefObject<HTMLButtonElement>;
}

export function ListSectionItem({
  item: { result, section },
  totalIndex,
  highlightedIndex,
  isMouseActive,
  onSelect,
  highlightedRef,
}: ListSectionProps) {
  const isHighlighted = totalIndex === highlightedIndex;
  return (
    <button
      data-testid="global-search__item"
      key={result.id}
      ref={isHighlighted ? highlightedRef : undefined}
      tabIndex={-1}
      className={clsx(
        "block rounded-md px-2 py-1.5 w-full whitespace-nowrap truncate text-left text-blue-grey-800 focus:bg-platform-blue-50 focus:outline-hidden",
        {
          "bg-platform-blue-50": isHighlighted && !isMouseActive,
          "hover:bg-platform-blue-50": isMouseActive,
        }
      )}
      onClick={() => onSelect({ result, section })}
    >
      <span className="flex w-full min-w-0 items-center justify-between gap-2">
        <span className="truncate min-w-0 flex-1 text-left">{result.title}</span>
        {section.id === "sites" && result.workspace ? (
          <WorkspaceBadge workspace={result.workspace} className="pointer-events-none" />
        ) : null}
      </span>
    </button>
  );
}
